export default {
  stats: {
    orders: 'Commandes',
    sales: "Chiffre d'affaires",
  },
};
